import { IPictogramFields } from '@/types/contentful';
import { Pictogram } from '@greenlightme/ui/dist/v2';
import React from 'react';

export default function PictogramComponent({
  size,
  type,
  icon,
  color,
  shape,
  inverse
}: IPictogramFields) {
  return (
    <Pictogram
      size={size}
      type={type}
      inverse={inverse}
      icon={{ fileName: icon }}
      color={color}
      shape={shape}
    />
  );
}
